import React from 'react';
import PropTypes from 'prop-types';
import { Tab, Tabs } from '@grupa-pracuj/react-tabs';

import category from 'src/types/category';

import { sendEventClick } from 'src/api/tracker';

import styles from 'src/components/MobileTabs.scss';

const MobileTabs = ({ categories, activateTab }) => (
  <Tabs
    customClasses={{
      customClass: styles['tabs-container'],
      customWrapper: styles['tabs-wrapper'],
      customUnderline: styles['tabs-underline'],
      customBorder: styles['tabs-border'],
    }}
    customTabClasses={{
      customClass: styles.tab,
      customActiveClass: styles['tab--active'],
    }}
    initialActiveTab={String(categories[0].id)}
  >
    {categories.map(({ id, name }, index) => (
      <Tab
        key={id}
        id={String(id)}
        onClick={() => {
          activateTab(id);
          sendEventClick(`advices_category_${id}`, index);
        }}
      >
        {name}
      </Tab>
    ))}
  </Tabs>
);

MobileTabs.propTypes = {
  activateTab: PropTypes.func.isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape(category)).isRequired,
};

export default MobileTabs;
